import globals from '../../../globals';
import { _sendWithAxios, _sendWithAxiosBlob } from '../../api'

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

export const filialCentroDistribuicaoSeller = async (pagina, idEmpresa) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialCentroDistribuicaoSeller/listar-filial-cd/${idEmpresa}/${pagina}/10`, 'GET')
}

export const filialCentroDistribuicaoSellerComFiltro = async (idEmpresa, filtro, pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialCentroDistribuicaoSeller/listar-filial-cd/${idEmpresa}/${filtro}/${pagina}/10`, 'GET')
}

export const detalheFilialCentroDistribuicaoSeller = async (idCentroDistribuicao) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialCentroDistribuicaoSeller/detalhes-filial-cd-seller/${idCentroDistribuicao}`, 'GET')
}

export const cadastrarFilialCentroDistribuicaoSeller = async (data, idEmpresaSeller) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialCentroDistribuicaoSeller/cadastrar-filial-cd-seller/${idEmpresaSeller}`, 'POST', data)
}

export const editarFilialCentroDistribuicaoSeller = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialCentroDistribuicaoSeller/atualizar-filial-cd-seller`, 'PUT', data)
}

export const inativarFilialCentroDistribuicaoSeller = async (idCentroDistribuicao) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialCentroDistribuicaoSeller/inativar-filial-cd-seller/${idCentroDistribuicao}`, 'PUT')
}

export const ativarFilialCentroDistribuicaoSeller= async (idCentroDistribuicao) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialCentroDistribuicaoSeller/ativar-filial-cd-seller/${idCentroDistribuicao}`, 'PUT')
}

export const gerarExelFilialCentroDistribuicaoSeller = async (idEmpresa) => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}FilialCentroDistribuicaoSeller/gerar-exel-filial-cd/${idEmpresa}`, 'GET')
}